import React from "react";
import PropTypes from "prop-types";

// Sebelum ini tidak ada Error Boundary sama sekali di seluruh aplikasi, jadi
// satu galat render di mana pun memutihkan seluruh halaman — persis yang
// terjadi pada bug /sub-kategory/<id tak ada> sebelum 260d95b. Komponen ini
// menahan galat itu dan menampilkan pesan yang bisa dibaca.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { galat: null };
  }

  static getDerivedStateFromError(galat) {
    return { galat };
  }

  componentDidCatch(galat, info) {
    console.error("Galat render tertangkap Error Boundary:", galat, info?.componentStack);
  }

  render() {
    if (this.state.galat) {
      return (
        <div className="page-content">
          <div className="container">
            <div className="row">
              <div className="col-lg-12" style={{ textAlign: "center", padding: "60px 0" }}>
                <h4>Halaman ini gagal ditampilkan.</h4>
                <p>
                  Terjadi kesalahan saat menyiapkan tampilan. Coba muat ulang
                  halaman; kalau masih gagal, kembali ke beranda.
                </p>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => window.location.reload()}
                >
                  Muat ulang halaman
                </button>
                &nbsp;
                <a className="btn btn-secondary" href="/home">
                  Kembali ke beranda
                </a>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node,
};

export default ErrorBoundary;
